import { Image } from '@shopify/hydrogen'
import { Image as ImageType } from '@shopify/hydrogen/storefront-api-types'
import styles from '../../assets/scss/components/products/products.module.scss'

export const ProductNote: React.FC<{ image?: ImageType }> = ({ image }) => {
  if (!image) {
    return null
  }

  return <Image className={styles.note} data={image} />
}
